export default {"mobile-shop":{},"global":{"project":"測試項目名稱","boundaryErrorTitle":"哎呀，出錯了！","apologize":"抱歉，應用程序遇到了一些問題。","retry":"重試","noData":"暫無數據"}}